<template>
    <div class="label-playing-wrapper">
        <div class="label-playing" >
            <div class="label-playing__item label-playing__item_1" />
            <div class="label-playing__item label-playing__item_2" />
            <div class="label-playing__item label-playing__item_3" />
        </div>
    </div>
</template>

<style lang="scss">
    @import url("styles.scss");
</style>